var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6.072L2.917 7.24v20.475l2.333 1.16.014-.017V6.088l-.014-.016z",
    fill: "#8C3123"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.735 25.902L5.25 28.874V6.072L17.735 8.98v16.923z",
    fill: "#E05243"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1 21.25l5.295.674.033-.077.03-8.683-.063-.068-5.296.664v7.49",
    fill: "#8C3123"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.395 25.936L29.54 28.88l.019-.03V6.092l-.02-.02-12.144 2.94v16.923",
    fill: "#8C3123"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.692 21.25l-5.297.674v-8.828l5.297.664v7.49z",
    fill: "#E05243"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.692 10.138l-5.297.966-5.296-.966 5.29-1.386 5.303 1.386z",
    fill: "#5E1F18"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.692 24.862l-5.297-.972-5.296.972 5.29 1.477 5.303-1.477z",
    fill: "#F2B0A9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1 10.138l5.295-1.31.043-.013V.035L17.395 0l-5.296 2.648v7.49z",
    fill: "#8C3123"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.692 10.138l-5.297-1.31V0l5.297 2.648v7.49z",
    fill: "#E05243"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.394 35l-5.296-2.647v-7.49l5.296 1.31.078.088-.02 8.586-.058.153z",
    fill: "#8C3123"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.395 35l5.297-2.648v-7.49l-5.297 1.31V35zM29.54 6.072l2.334 1.167v20.475l-2.334 1.167V6.072z",
    fill: "#E05243"
  })));
}

export default SvgIcon;